import React from 'react';
import {Button, Card, CardContent, Container, Grid, GridColumn, IButtonProps} from '../../components';
import gfm from 'remark-gfm';
import ReactMarkdown from 'react-markdown';
import classNames from 'classnames';
import Scroll from '../../components/scroll-fade/scroll';

export interface ITemplateAgreementProps {
    title: string;
    button: IButtonProps;
    content: string;
    onSubmit?: () => void;
    className?: string;
}

const TemplateAgreement = (props: ITemplateAgreementProps): JSX.Element => {
    const className: string = classNames(
        props.className,
    );

    const onSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
        event.preventDefault();
        if (props.onSubmit) {
            props.onSubmit();
        }
    };

    return (
        <Container>
            <Grid justify={['center-xs']}>
                <GridColumn width={['md-8', 'lg-6']}>
                    <form className={className} onSubmit={onSubmit}>
                        <div className="text text-center">
                            <h1 className="h3">{props.title}</h1>
                            <Grid>
                                <Card className={'agreement'}>
                                    <Scroll>
                                        <CardContent className={'card_content__agreement'}>
                                            <ReactMarkdown className="text text-left" remarkPlugins={[gfm]}>{props.content}</ReactMarkdown>
                                        </CardContent>
                                    </Scroll>
                                </Card>
                            </Grid>
                            <Grid wrap={['xs']} justify={['center-xs']}>
                                <GridColumn width={['xs-12', 'sm-6']}>
                                    <Button {...props.button} block={true} />
                                    <button type='submit' style={{display: 'none'}}/>
                                </GridColumn>
                            </Grid>
                        </div>
                    </form>
                </GridColumn>
            </Grid>
        </Container>
    );
};

export default TemplateAgreement;
